// extracted by mini-css-extract-plugin
export default {"textarea":"Textarea_textarea__oQJL3","textareaContainer":"Textarea_textareaContainer__vKINN"};